import React, { Component } from 'react'
import { YearContainer } from '../../Commons/Year'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import {
    translateFormFieldLabel,
    translateFormFieldValue,
} from '../../../../../../../helpers/collaborativeIndexations'

class Event extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        hasDefaultEventPlace: PropTypes.bool.isRequired
    }

    constructor(props)
    {
        super(props)

        this.updateEventPlace = this.updateEventPlace.bind(this)
    }

    updateEventPlace(event)
    {
        this.props.updateFieldValue("eventPlace", event.target.value)
    }

    render()
    {
        const { t, fields, hasDefaultEventPlace } = this.props

        return (
            <div>
                <div>
                    { t("visualizer:toolbar.left.collaborativeIndexationCreation.form.population_census.steps.event.title") }
                </div>
                <div className={"form-group"}>
                    <label>{translateFormFieldLabel(t, "eventType")}</label>
                    <span className={"readonly-field"}>{translateFormFieldValue(t, "eventType", "population_census")}</span>
                </div>
                <YearContainer fieldName={"eventYear"} label={translateFormFieldLabel(t, "eventYear")} hasFocus={true} />
                <div className={"form-group"}>
                    <label htmlFor={'eventPlace'}>{translateFormFieldLabel(t, "eventPlace")}</label>
                    {hasDefaultEventPlace
                        ? <span className={"readonly-field"}>{fields.eventPlace}</span>
                        : <input
                            id={'eventPlace'}
                            type={"text"}
                            defaultValue={fields.eventPlace}
                            onChange={this.updateEventPlace}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default withTranslation()(Event)
